import StatGrid from '@commons/stats'
import Column from '@components/column'
import SectionHeading from '@commons/headings/section'
import Tabs from '@commons/tabs'
import Orders from './orders'
import Medicines from './medicines'
import RefundRequests from './refundRequests'
const AdminMedicineManagementPage = () => {
  const items: any = [
    {
      title: 'Total Medicine Orders',
      value: '155',
      icon: 'appointment',
      bg: 'orange100',
    },
    {
      title: 'Pending Medicine Orders',
      value: '23',
      icon: 'lab',
      bg: 'yellow150',
    },
    {
      title: 'Cancelled Medicine Orders',
      value: '23',
      icon: 'medicine',
      bg: 'green150',
    },
    {
      title: 'Total Medicine Sale',
      value: '23',
      icon: 'money',
      bg: 'yellow50',
    },
  ]
  const tabs = [
    {
      title: 'Medicine List',
      key: 'medicine-list',
      Component: Medicines,
    },
    {
      title: 'Medicine Orders',
      key: 'medicine-order',
      Component: Orders,
    },
    {
      title: 'Refund Request',
      key: 'refund-request',
      Component: RefundRequests,
    },
  ]
  return (
    <Column rowGap={20}>
      <StatGrid items={items} />
      <SectionHeading title="Medicine Management" />
      <Tabs items={tabs} />
    </Column>
  )
}

export default AdminMedicineManagementPage
